import { render, staticRenderFns } from "./DragAndDropSimple.vue?vue&type=template&id=7416e45a"
import script from "./DragAndDropSimple.vue?vue&type=script&lang=js"
export * from "./DragAndDropSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports